import * as Sentry from '@sentry/react';
import type { Router } from '@tanstack/react-router';

import { config } from '@/config/config';
import type { routeTree } from '@/routeTree.gen';

export const initSentry = (router: Router<typeof routeTree>) => {
	if (!config.enableSentry) {
		console.info(
			`Sentry is not enabled for environment ${config.VITE_ENVIRONMENT}.`,
		);
		return;
	}

	Sentry.init({
		dsn: config.VITE_SENTRY_DSN,
		integrations: [Sentry.tanstackRouterBrowserTracingIntegration(router)],
		enableLogs: false,
		tracesSampleRate: config.sentryTracesSampleRate,
		// The API is served from another origin, so trace headers are only attached when it is
		// listed here; the backend continues the trace from sentry-trace/baggage.
		tracePropagationTargets: [config.apiUrl],
		profilesSampleRate: 0,
		replaysOnErrorSampleRate: 0,
		environment: config.VITE_ENVIRONMENT,
		sendDefaultPii: false,
	});
};
